import React from 'react';
import Icon from '../../../components/AppIcon';

const WellnessSlider = ({ 
  label, 
  value, 
  onChange, 
  icon, 
  description,
  anchors = [],
  className = "" 
}) => {
  const getSliderColor = (val) => {
    if (val <= 2) return 'bg-success';
    if (val <= 4) return 'bg-warning';
    return 'bg-error';
  };

  const getTrackGradient = (val) => {
    const percentage = ((val - 1) / 6) * 100;
    // Dark green at 1-2 (0-16.67%), yellow at 4 (50%), dark red at 6-7 (83.33-100%)
    return {
      background: `linear-gradient(to right, 
        #047857 0%, 
        #047857 16.67%, 
        #EAB308 50%, 
        #B91C1C 83.33%, 
        #B91C1C 100%)`
    };
  };

  return (
    <div className={`bg-card rounded-lg p-6 border border-border ${className}`}>
      <div className="flex items-center space-x-3 mb-4">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${getSliderColor(value)}`}>
          <Icon name={icon} size={20} color="white" strokeWidth={2} />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-text-primary">{label}</h3>
          <p className="text-sm text-text-secondary">{description}</p>
        </div>
        <div className="text-right">
          <span className="text-2xl font-bold text-text-primary">{value}</span>
          <span className="text-sm text-text-secondary">/7</span>
        </div>
      </div>
      <div className="space-y-4">
        <div className="relative">
          <input
            type="range"
            min="1"
            max="7"
            step="1"
            value={value}
            onChange={(e) => onChange(parseInt(e?.target?.value))}
            className="w-full h-3 rounded-lg appearance-none cursor-pointer slider-thumb"
            style={getTrackGradient(value)}
          />
          
          {/* Scale markers */}
          <div className="flex justify-between mt-2 px-1">
            {[1, 2, 3, 4, 5, 6, 7]?.map((num) => (
              <div key={num} className="flex flex-col items-center">
                <div className={`w-2 h-2 rounded-full ${
                  num <= value ? 'bg-text-primary' : 'bg-border'
                }`} />
                <span className="text-xs text-text-secondary mt-1">{num}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Anchor descriptions */}
        {anchors?.length > 0 && (
          <div className="flex justify-between text-xs text-text-secondary">
            <span className="text-left max-w-[30%]">{anchors?.[0]}</span>
            <span className="text-center max-w-[30%]">{anchors?.[1]}</span>
            <span className="text-right max-w-[30%]">{anchors?.[2]}</span>
          </div>
        )}
      </div>
      <style jsx>{`
        .slider-thumb::-webkit-slider-thumb {
          appearance: none;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: #2563EB;
          border: 3px solid white;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          cursor: pointer;
        }
        
        .slider-thumb::-moz-range-thumb {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: #2563EB;
          border: 3px solid white;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          cursor: pointer;
        }
      `}</style>
    </div>
  );
};

export default WellnessSlider;